import clsx from "clsx";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { LocaleContext } from "./localization_wrapper";
import { tellitStoryId } from "../flows";

function buildTellitStoryURL(storyId) {
  return `https://tell-it-production-public.s3.eu-central-1.amazonaws.com/${storyId}/story.json`;
}

export function TellitPage({ handleSave, children, className, page }) {
  const i18n = useContext(LocaleContext);
  const formRef = useRef(null);
  const flow = page.treesponse.getAnswer("flow");
  const street = page.treesponse.getAnswer("street");
  const scenarioChoice = page.treesponse.getAnswer("scenario_choice");
  const storyId = tellitStoryId(flow, street, i18n.locale);
  const storyURL = storyId ? buildTellitStoryURL(storyId) : null;

  useEffect(() => {
    if (page.key !== "closed" || scenarioChoice === undefined) return;

    const timeoutId = window.setTimeout(() => {
      const closedQuestion =
        formRef.current?.querySelector(".question--tellit");
      closedQuestion?.scrollIntoView({
        block: "center",
      });
    }, 150);

    return () => window.clearTimeout(timeoutId);
  }, [page.key, scenarioChoice]);

  return (
    <>
      <ScrollIndicator />
      {storyURL && <tellit-player data-story-url={storyURL}></tellit-player>}
      {!storyURL && (
        <section className="tellit-fallback">
          <h1 className="tellit-fallback__title">
            {i18n.t("tellit_fallback.title")}
          </h1>
          <p className="tellit-fallback__description">
            {i18n.t("tellit_fallback.description")}
          </p>
        </section>
      )}
      <form
        action=""
        onSubmit={handleSave}
        className={clsx(className, "tellit-form")}
        ref={formRef}
      >
        <div className="tellit-form__container">{children}</div>
      </form>
    </>
  );
}

const SCROLL_INDICATOR_UNTIL = 250;

function ScrollIndicator() {
  const i18n = useContext(LocaleContext);
  const [hidden, setHidden] = useState(window.scrollY > SCROLL_INDICATOR_UNTIL);

  const onScroll = useCallback(() => {
    setHidden(window.scrollY > SCROLL_INDICATOR_UNTIL);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [onScroll]);

  return (
    <div className="scroll-indicator" hidden={hidden}>
      <p className="scroll-indicator__text">{i18n.t("general.scroll_down")}</p>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="currentColor"
        className="scroll-indicator__icon"
        aria-hidden="true"
      >
        <path d="M8.00024 12.696L4.00024 8.69603L4.93358 7.7627L8.00024 10.8127L11.0669 7.7627L12.0002 8.69603L8.00024 12.696ZM8.00024 8.69603L4.00024 4.69603L4.93358 3.7627L8.00024 6.8127L11.0669 3.7627L12.0002 4.69603L8.00024 8.69603Z" />
      </svg>
    </div>
  );
}
